import { ReactElement, useState } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import styled from 'styled-components'
import { useFormikContext } from 'formik'

import FormLayout from 'components/v2/FormLayout'
import Heading from 'components/v2/Heading'
import { IEditServiceForm } from 'features/Services/components/EditService/types'
import { getPlanningsByService } from 'models/services'
import { PlanningItem } from './PlanningItem'
import { PlanningModal } from './PlanningModal'
import { IPlanningsCardProps } from './types'
import { device } from 'utils/style'

const messages = defineMessages({
  planningLabel: {
    id: 'services.form.section.planning.label',
    defaultMessage: 'Planning {planningIndex}'
  }
})

const PlanningGrid = styled.div<TSFixMe>`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media (${device.laptop}) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const PlanningsCard = ({ oldService, isEndDateOptional }: IPlanningsCardProps): ReactElement => {
  const intl = useIntl()
  const { values } = useFormikContext<IEditServiceForm>()
  const [currentPlanningIndex, setCurrentPlanningIndex] = useState(-1)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleToggleModal = (planningIndex: number): void => {
    setCurrentPlanningIndex(planningIndex)
    setIsModalOpen(!isModalOpen)
  }

  const handleCloseModal = (): void => {
    handleToggleModal(-1)
  }

  const plannings = getPlanningsByService(values.services[0])
  const reversedPlannings = [...plannings].reverse()

  return (
    <FormLayout.Card>
      <FormLayout.CardHeader>
        <Heading.H4>
          <FormattedMessage id="services.form.section.planning.title" defaultMessage="Planning" />
        </Heading.H4>
      </FormLayout.CardHeader>
      <PlanningGrid>
        {reversedPlannings.map((planning, reversedPlanningIndex): ReactElement => {
          const planningIndex = plannings.length - reversedPlanningIndex - 1
          const isLastPlanning = reversedPlanningIndex === plannings.length - 1
          const isSinglePlanning = plannings.length % 2 !== 0
          const isLastSingleItem = isLastPlanning && isSinglePlanning

          return (
            <PlanningItem
              key={planningIndex}
              isLastSingleItem={isLastSingleItem}
              startDate={planning.startDate}
              endDate={planning.endDate}
              stops={planning.stops}
              label={intl.formatMessage(messages.planningLabel, { planningIndex: planningIndex + 1 })}
              onClick={(): void => handleToggleModal(planningIndex)}
            />
          )
        })}
      </PlanningGrid>
      {isModalOpen && (
        <PlanningModal
          companyId={values.companyId}
          oldService={oldService}
          plannings={plannings}
          activePlanningIndex={currentPlanningIndex}
          onClose={handleCloseModal}
          isEndDateOptional={isEndDateOptional}
        />
      )}
    </FormLayout.Card>
  )
}
